import { Container } from 'reactstrap'
import HistoryList from '../../../Material/HistoryList'

const HistoryTab = ({ branchId }) => (
    <Container fluid className="p-4" style={{ backgroundColor: '#fff', borderRadius: '5px' }}>
        <HistoryList objectIds={[branchId]} subject="this branch" emptyText="No history found" />
    </Container>
)

export default HistoryTab
